import { Country } from './openApi';
import { ApiResponseType } from './api';
import { SortTypeEnum } from './index';
import { CandidateReviewType, DiscardEnum } from './review';
import { SuspendStatusEnum, SuspensionDecisionEnum } from './suspension';

export type CompanyListRequestType = {
    Start: number;
    Limit: number;
    'Name.FilterValue'?: string;
    'Name.SortType'?: SortTypeEnum;
    'Industry.FilterValue'?: string;
    'Industry.SortType'?: SortTypeEnum;
    'CityDistrict.FilterValue'?: string;
    'CityDistrict.SortType'?: SortTypeEnum;
    'State.FilterValue'?: string;
    'State.SortType'?: SortTypeEnum;
    'Rating.FilterValue'?: string;
    'Rating.SortType'?: SortTypeEnum;
    'Status.FilterValue'?: string;
    'Status.SortType'?: SortTypeEnum;
};

export type CompanyProfileType = {
    id: string;
    creatorId: string;
    active: boolean;
    name: string;
    industry: string;
    foundedYear: number;
    aboutUs: string;
    phone: string;
    companyAddress: string;
    cityDistrict: string;
    state: string;
    country: string;
    creatorEmail: string;
    salesOwner: string;
    postalCode: string;
    email: string;
    website: string;
    gstNumber: {
        value: string | null;
    };
    avatarUrl: string;
    reviewsCount: number;
    rating: {
        value: number;
    };
    contractComplianceQuantity: number;
    contractViolationQuantity: number;
    suspendStatus: SuspendStatusEnum;
    bannerUrl: string;
    companyReviews: CandidateReviewType[];
    location: string;
    suspendReasonOtherText: string;
    suspendReasons: string[];
    cinNumber: string;
    fileUrl: string;
    comments: string;
    ownerPhoneNumber: string;
    salesOwnerName: string;
    compCountryCode: string;
    companyInviteType: number;
    ownerCountryCode: string;
    userCountryCode?: string;
    onboardedDate?: Date | null;
    // offerReviewState: OfferReviewStateEnum;
    // reviewId: string | null;
    // offerId: string | null;
};

export type RewardsRequestType = {
    companyId: string;
    Start: number;
    Limit: number;
    'ServiceType.FilterValue'?: string;
    'ServiceType.SortType'?: SortTypeEnum;
    'Date.FilterValue'?: string;
    'Date.SortType'?: SortTypeEnum;
    'DoneBy.FilterValue'?: string;
    'DoneBy.SortType'?: SortTypeEnum;
    'Points.FilterValue'?: string;
    'Points.SortType'?: SortTypeEnum;
    'TotalPoints.FilterValue'?: string;
    'TotalPoints.SortType'?: SortTypeEnum;
};

export type RewardsListType = {
    serviceType: string;
    date: Date;
    doneBy: string;
    points: number;
    totalPoints: number;
};

export type CompanyReportFromCandidateRequestType = {
    Start: number;
    Limit: number;
};

export type CandidateMatchRequestType = {
    fullName: string;
    email: string;
    phoneNumber: string;
    matchType: number;
    candidateId: string;
};

export enum  CandidateStatusEnum {
    Joined = 0,
    Uploaded = 1,
    Pending = 2,
    Deleted = 3,
    Invited = 4,
    ProvisionallyJoined = 5
}

export type CandidateMatchResponseType = {
    avatarImagUrl: string;
    candidateStatus: number;
    countryStateCity: { country: string; city: string; state: string; unclaimedCountry: string | null };
    dob: string;
    email: string;
    fullName: string;
    gender: number;
    isEmailMatching: boolean;
    isFullNameMatching: boolean;
    isPhoneNumberMatching: boolean;
    phone: string;
    userId: string;
};

export type CompanyReportFromCandidateType = {
    id: string;
    candidateId: string;
    reportedByFirstName: string;
    reportedByLastName: string;
    companyId: string;
    companyName: string;
    companyCityDistrict: string;
    companyState: string;
    companyIndustry: string;
    reportedDate: Date;
    companySuspendReason: string[];
    suspendReasonOtherText: string;
    companyAvatarUrl: string;
    candidateAvatarUrl: string;
    isFlagged: boolean;
    suspensionDecision: SuspensionDecisionEnum;
    disCardStatus: DiscardEnum;
    suspendReasons: string[];
    companySuspendReasonText: string;
    companySuspensionStatus: SuspendStatusEnum;
};

export type CompanyProfileResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: CompanyProfileType;
};

export type CompanyListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: CompanyProfileType[];
        hasMore: boolean;
        count: number;
    };
};

export type RewardsListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: RewardsListType[];
        hasMore: boolean;
        count: number;
    };
};

export type CompanyReportFromCandidateListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: CompanyReportFromCandidateType[];
        hasMore: boolean;
        count: number;
    };
};

export type CandidateMatchedListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: CandidateMatchResponseType[];
};

export type CompanyCountType = {
    totalCompaniesCount: number;
    totalCompaniesGrowth: number;
    activeCompaniesCount: number;
    activeCompaniesGrowth: number;
    suspendedCompaniesCount: number;
    suspendedCompaniesGrowth: number;
    reportedByCandidatesCompaniesCount: number;
    reportedByCandidatesCompaniesGrowth: number;
};

export type CompanyCountResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: CompanyCountType;
};

export type RewardCountType = {
    companyTotalPoints: number;
    companyTotaDataPunched: number;
    companyTotalOffersReleased: number;
    companyTotaReviewsSubmitted: number;
};

export type RewardCountResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: RewardCountType;
};

export type CompanyVerificationListResponseType = Omit<ApiResponseType, 'result'> & {
    result: {
        companies: CompanyProfileType[];
        hasMore: boolean;
        count: number;
    };
};

export type ScreenXCompanyVerificationListResponseType = Omit<ApiResponseType, 'result'> & {
    result: {
        companies: ScreenXCompanyProfileType[];
        hasMore: boolean;
        count: number;
        salesOwners: ScreenXSalesOwnerProfileType[];
    };
};

export type ScreenXSalesOwnerProfileType = {
    id: number;
    name: string;
    walleroEmpId: string;
    email: string;
};

export type ScreenXCompanyProfileType = {
    id: string;
    creatorId: string;
    active: boolean;
    name: string;
    industry: string;
    foundedYear: number;
    aboutUs: string;
    phone: string;
    companyAddress: string;
    cityName: string;
    stateName: string;
    countryName: string;
    creatorEmail: string;
    salesOwnerName: string;
    postalCode: string;
    email: string;
    website: string;
    gstNumber: {
        value: string | null;
    };
    avatarUrl: string;
    reviewsCount: number;
    rating: {
        value: number;
    };
    contractComplianceQuantity: number;
    contractViolationQuantity: number;
    suspendStatus: SuspendStatusEnum;
    bannerUrl: string;
    companyReviews: CandidateReviewType[];
    location: string;
    suspendReasonOtherText: string;
    suspendReasons: string[];
    cinNumber: string;
    fileUrl: string;
    comments: string;
    ownerPhoneNumber: string;
    compCountryCode: string;
    companyInviteType: number;
    ownerCountryCode: string;
    userCountryCode?: string;
    // offerReviewState: OfferReviewStateEnum;
    // reviewId: string | null;
    // offerId: string | null;
    state: string;
    cityDistrict: string;
    country: string;
    salesOwner: string;
    salesOwnerEmpId: string;
    documentUploadedDate: Date;
};

export type ScreenXCompanyListResponseType = Omit<ApiResponseType, 'result'> & {
    result: {
        companies: ScreenXCompanyListProfileType[];
        hasMore: boolean;
        count: number;
    };
};
export type ScreenXCompanyListProfileType = {
    id: string;
    creatorId: string;
    active: boolean;
    name: string;
    industry: string;
    foundedYear: number;
    aboutUs: string;
    phone: string;
    companyAddress: string;
    cityName: string;
    stateName: string;
    countryName: string;
    creatorEmail: string;
    salesOwnerName: string;
    postalCode: string;
    email: string;
    website: string;
    gstNumber: {
        value: string | null;
    };
    avatarUrl: string;
    reviewsCount: number;
    rating: {
        value: number;
    };
    contractComplianceQuantity: number;
    contractViolationQuantity: number;
    suspendStatus: SuspendStatusEnum;
    bannerUrl: string;
    companyReviews: CandidateReviewType[];
    location: string;
    suspendReasonOtherText: string;
    suspendReasons: string[];
    cinNumber: string;
    fileUrl: string;
    comments: string;
    ownerPhoneNumber: string;
    compCountryCode: string;
    companyInviteType: number;
    ownerCountryCode: string;
    userCountryCode?: string;
    // offerReviewState: OfferReviewStateEnum;
    // reviewId: string | null;
    // offerId: string | null;
    state: string;
    cityDistrict: string;
    country: string;
    salesOwner: string;
    salesOwnerEmpId: string;
    isActive: boolean;
};

export type ScreenXCompanyLeadListResponseType = Omit<ApiResponseType, 'result'> & {
    result: {
        items: CompanyProfileType[];
        hasMore: boolean;
        count: number;
    };
};
